module.exports = __webpack_public_path__ + "img/w3_bookmark_black.4da3ef5a.png";